import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { PartnerCategory } from '../../entities/control-tables/partner-category-entity';


export class PartnerCategoryRequest extends BaseRequest{
  partnerCategory : PartnerCategory;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.partnerCategory = new PartnerCategory();
  }
}